export const TIP_KAYNAK_MAP: Record<string, string[]> = {
  olcüler:   ['urun_olcu_en', 'urun_olcu_boy', 'urun_olcu_yukseklik'],
  uzunluk:   ['urun_olcu_boy'],
  en:        ['urun_olcu_en'],
  yukseklik: ['urun_olcu_yukseklik'],
  agirlik:   ['urun_agirlik'],
  ozel:      [],
};

export const TIP_ETIKET_MAP: Record<string, string> = {
  olcüler:   'Ölçüler (En x Boy x Yükseklik)',
  uzunluk:   'Uzunluk',
  en:        'En',
  yukseklik: 'Yükseklik',
  agirlik:   'Ağırlık',
  ozel:      'Özel (Elle Giriş)',
};

// Ürün nesnesinden özellik değerini hesapla
export function urundenDegerHesapla(urun: any, tip: string): string | null {
  const kaynaklar = TIP_KAYNAK_MAP[tip] ?? [];
  if (kaynaklar.length === 0) return null;

  if (kaynaklar.length === 1) {
    const val = urun[kaynaklar[0]];
    return val !== null && val !== undefined ? String(Number(val)) : null;
  }

  const parcalar = kaynaklar
    .map(alan => urun[alan])
    .filter(v => v !== null && v !== undefined);

  if (parcalar.length !== kaynaklar.length) return null;
  return parcalar.map(v => String(Number(v))).join('x');
}

// "200x100x50" → "200 x 100 x 50 cm" formatla
export function degerFormatlaBirim(deger: string, birim: string | null): string {
  if (!deger) return '';
  if (deger.includes('x')) {
    return deger.split('x').join(' x ') + (birim ? ` ${birim}` : '');
  }
  return deger + (birim ? ` ${birim}` : '');
}
